import React from "react";

interface ContentCellDateProps {
  value?: string | Date | null;
  mode?: "date" | "datetime"; // default "date"
}

const ContentCellDate: React.FC<ContentCellDateProps> = ({
  value,
  mode = "date",
}) => {
  if (!value) return <span></span>;

  const date = typeof value === "string" ? new Date(value) : value;

  const pad = (n: number) => n.toString().padStart(2, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  if (mode === "date") {
    return <span>{`${day}/${month}/${year}`}</span>;
  }

  // mode === "datetime"
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return <span>{`${day}/${month}/${year} ${hours}:${minutes}:${seconds}`}</span>;
};

export default ContentCellDate;
